module.exports = __webpack_public_path__ + "media/18.979b4efb.mp3";